import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SettingState {
  name: string;
  logoImageAddress: string;
  instagramAddress: string;
  facebookAddress: string;
  telegramAddress: string;
  whatsappAddress: string;
  twitterAddress: string;
  aboutUsSummary: string;
  tell: string;
  fax: string;
  address: string;
  postalCode: string;
  googleMapLink: string;
  latitudeAndLongitude: string;
  sliderImageCount: number;
  homePageNewsCount: number;
}

const initialState: SettingState = {
  name: "مجمع هماهنگی اصناف کشاورزی استان مازندران",
  logoImageAddress: "",
  instagramAddress: "https://instagram.com",
  facebookAddress: "https://facebook.com",
  telegramAddress: "https://telegram.me",
  whatsappAddress: "https://whatsapp.com",
  twitterAddress: "https://twitter.com",
  aboutUsSummary:
    "به سامانه جامع بهره برداران کشاورزی خوش آمدید، شما می توتانید با ثبت نام در این سامانه از خدمات مجمع هماهنگی اصناف کشاورزی استان مازندران بهره مند شوید .",
  tell: "۰۲۱۵۴۶۶۵۹۲۳۱",
  fax: "۰۲۱۵۴۶۶۵۹۲۳۱",
  address:
    "تهران - خیابان شریعتی - نرسیده به پل سید خندان - ورودی ۲۲ - ساختمان مرکزی",
  postalCode: "۱۱۱۱۱۱۱۱۱",
  googleMapLink:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3204.623834154988!2d53.0494553156805!3d36.563181979998106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDMzJzQ3LjUiTiA1M8KwMDMnMDUuOSJF!5e0!3m2!1sen!2sus!4v1629196622351!5m2!1sen!2sus",
  latitudeAndLongitude: "1N,32E",
  sliderImageCount: 4,
  homePageNewsCount: 3,
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setSetting: (state, action: PayloadAction<Partial<SettingState>>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setSetting } = settingSlice.actions;
export const settingReducer = settingSlice.reducer;
